import { make } from 'vuex-pathify';
import { ReferenceTypes } from '@/modules/global-settings/miscellaneous/services/reference-types.service';
// Create a new instance of the ReferenceTypes class
const service = new ReferenceTypes();
// Reference Types module state
export const state = {
  referenceTypes: []
};
// Reference Types module mutations
export const mutations = {
  ...make.mutations(state)
};
// Reference Types module getters
export const getters = {
  ...make.getters(state),
  activeReferenceTypes(state) {
    return state.referenceTypes.filter((r) => r.status == true);
  }
};
// Reference Types module actions
export const actions = {
  /**
   * Fetches all Reference Types
   * @param {Object} context - Vuex action context
   * @returns {Array} Array of Reference Types
   * @private This sets the Reference Types in the state
   */
  async fetchReferenceTypes({ commit }) {
    const { status, data } = await service.fetchReferenceTypes();
    if (status == 200) {
      commit('SET_REFERENCE_TYPES', data);
    }
    return status;
  },

  /**
   * Updates a Reference Type
   * @param {Object} context - Vuex action context
   * @param {Object} payload - Reference payload
   * @param {String} payload.id - Reference Type ID
   * @param {Object} payload.updates - Reference Type updates
   * @returns {Number} HTTP status code
   * @private This updates the Reference Types in the state
   */
  async updateReferenceType({ dispatch }, { id, updates }) {
    const { status } = await service.updateReferenceType(id, updates);
    if (status == 200) {
      dispatch('fetchReferenceTypes');
    }
    return status;
  },

  /**
   * Creates a Reference Type
   * @param {Object} context - Vuex action context
   * @param {Object} payload - Reference Type
   * @returns {Number} HTTP status code
   * @private This updates the Reference Types in the state
   */
  async createReferenceType({ dispatch }, payload) {
    const { status } = await service.createReferenceType(payload);
    if (status == 201) {
      dispatch('fetchReferenceTypes');
    }
    return status;
  },

  /**
   * Deletes a Reference Type
   * @param {Object} context - Vuex action context
   * @param {String} id - Reference Type ID
   * @returns {Number} HTTP status code
   * @private This updates the Reference Types in the state
   */
  async deleteReferenceType({ dispatch }, payload) {
    const { status } = await service.deleteReferenceType(payload);
    if (status == 200) {
      dispatch('fetchReferenceTypes');
    }
    return status;
  }
};
